// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__23qL2","content":"GlobalSearch_content__1z_qT"};